import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from 'lucide-react'

const OPCIONES_TAMANIO_DEFECTO = [20, 50, 100]

const estiloBotonPagina =
  'inline-flex h-9 items-center justify-center gap-1 rounded-lg border border-slate-300 px-2.5 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent'

// Controles de paginación reutilizados por Ventas POS y Pagos pendientes.
// No sabe nada de qué está paginando: solo recibe números y avisa cambios.
function Paginacion({
  pagina,
  totalPaginas,
  tamanioPagina,
  totalRegistros,
  indiceInicio,
  indiceFin,
  etiquetaRegistros = 'registros',
  opcionesTamanio = OPCIONES_TAMANIO_DEFECTO,
  onCambiarPagina,
  onCambiarTamanio,
}) {
  if (totalRegistros === 0) return null

  return (
    <div className="mt-4 flex flex-col gap-3 border-t border-slate-100 pt-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
        <p className="text-sm text-slate-500">
          Mostrando{' '}
          <span className="font-semibold text-slate-700">
            {indiceInicio}–{indiceFin}
          </span>{' '}
          de{' '}
          <span className="font-semibold text-slate-700">
            {totalRegistros}
          </span>{' '}
          {etiquetaRegistros}
        </p>

        <select
          value={tamanioPagina}
          onChange={(event) =>
            onCambiarTamanio(Number(event.target.value))
          }
          className="w-full rounded-lg border border-slate-300 bg-white px-2.5 py-1.5 text-xs font-semibold text-slate-600 outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 sm:w-auto"
        >
          {opcionesTamanio.map((opcion) => (
            <option key={opcion} value={opcion}>
              {opcion} por página
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-1.5">
        <button
          type="button"
          onClick={() => onCambiarPagina(1)}
          disabled={pagina <= 1}
          title="Primera página"
          aria-label="Primera página"
          className={estiloBotonPagina}
        >
          <ChevronsLeft size={16} />
        </button>

        <button
          type="button"
          onClick={() => onCambiarPagina(pagina - 1)}
          disabled={pagina <= 1}
          className={estiloBotonPagina}
        >
          <ChevronLeft size={16} />
          <span className="hidden sm:inline">Anterior</span>
        </button>

        <span className="whitespace-nowrap px-2 text-sm font-semibold text-slate-700">
          Página {pagina} de {totalPaginas}
        </span>

        <button
          type="button"
          onClick={() => onCambiarPagina(pagina + 1)}
          disabled={pagina >= totalPaginas}
          className={estiloBotonPagina}
        >
          <span className="hidden sm:inline">Siguiente</span>
          <ChevronRight size={16} />
        </button>

        <button
          type="button"
          onClick={() => onCambiarPagina(totalPaginas)}
          disabled={pagina >= totalPaginas}
          title="Última página"
          aria-label="Última página"
          className={estiloBotonPagina}
        >
          <ChevronsRight size={16} />
        </button>
      </div>
    </div>
  )
}

export default Paginacion
